import {
    GET_LIST,
    GET_ONE,
    GET_MANY,
    GET_MANY_REFERENCE,
    CREATE,
    UPDATE,
    DELETE,
} from 'react-admin';

export const validateUrl = (resource, type) => {
    switch (type) {
        case CREATE:
            break;
        case UPDATE:
            break;
        case GET_ONE:
            break;
        case GET_LIST:
        case GET_MANY:
        case GET_MANY_REFERENCE:
            break;
        case DELETE:
            break;
        default:
    }
    return resource;
}

export const mapRest2Http = (type, resource, data) => {
    switch (type) {
        case CREATE:
            break;
        case UPDATE:
            break;
        case GET_ONE:
            break;
        case GET_LIST:
        case GET_MANY:
        case GET_MANY_REFERENCE:
            break;
        case DELETE:
            break;
        default:
    }
    return data;
}

export const mapHttp2Rest = (type, resource, data) => {
    switch (type) {
        case CREATE:
            break;
        case UPDATE:
            break;
        case GET_ONE:
            break;
        case GET_LIST:
        case GET_MANY:
        case GET_MANY_REFERENCE:
            break;
        case DELETE:
            break;
        default:
    }
    return data;
}